import { useContext } from 'react';
import type { FeatureGateDisableContextValue } from '../components/FeatureGate';
import { FeatureGateDisableContext } from '../components/FeatureGate';

export function useFeatureGateDisableContext(): FeatureGateDisableContextValue {
  return useContext(FeatureGateDisableContext);
}
